<template>
  <section id="rules" class="page active">
    <div class="wrap">
      <div class="inner-top">
        <div class="eyebrow">Transparent by design</div>
        <h1 class="title">{{ t("rules_title") }}</h1>
        <p class="subtext">{{ t("rules_sub") }}</p>
      </div>
      <div class="panel">
        <h3>{{ t("rules_h3") }}</h3>
        <div class="steps">
          <div class="step">
            <b>{{ t("step1b") }}</b><span v-html="t('step1p')"></span>
          </div>
          <div class="step">
            <b>{{ t("step2b") }}</b><span v-html="t('step2p')"></span>
          </div>
          <div class="step">
            <b>{{ t("step3b") }}</b><span v-html="t('step3p')"></span>
          </div>
        </div>
        <div class="notice">{{ t("notice_rules") }}</div>
      </div>
      <div class="panel bottom-space" style="margin-top: 20px;">
        <h3>{{ t("prelaunch_title") }}</h3>
        <ul class="rules-list">
          <li v-for="n in 7" :key="n">{{ t("li" + n) }}</li>
        </ul>
        <div class="notice" style="margin-top: 22px">{{ t("notice_compliance") }}</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "RulesPage",
  props: {
    t: { type: Function, required: true },
  },
};
</script>
